module.exports = __webpack_public_path__ + "img/pattern_4.817ff448.png";